<template>
<div>
  <div class="header1">
    <h4>Guides</h4>
  </div>
  <div v-if="blogsdata" class="latestbuilds">
    <div v-for="blog in blogsdata" :key="blog" class="latestbuild">
      <v-card
        class="mx-auto build"
        max-width="400"
        min-height="200"
        outlined
        dark
        @click="goto_page(blog.id)"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-h5">
              {{ blog.title }}
            </v-list-item-title>
            <v-list-item-subtitle><strong>By : </strong> 
              <i>{{ blog.created_by }}</i>
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar
            tile
            size="80"
            color="grey"
          ><img src="../assets/Blog.jpg"></v-list-item-avatar>
        </v-list-item>

        <v-card-actions>
          <v-btn
            outlined
            rounded
            text
            class="foota"
            :href="'blog/'+blog.id"
          >
            Explore More
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
  <div v-if="loadingdata && blogsdata.length == 0" class="latestbuilds">
    <v-progress-circular
      :rotate="180"
      :size="100"
      :width="15"
      :value="value"
      color="blue"
    >
      {{ value }}
    </v-progress-circular>
  </div>
  <div v-if="nodata" class="header2">
    <img src="../assets/404.png" alt="404(Not Found)">
      <h1>404</h1>
      <p>No Data Found</p>
  </div>
</div>
</template>

<script>  
import axios from 'axios';

export default {
    name: 'Home',
    components: {

    },
    data: () => ({
      blogsdata : [],
      loadingdata: false,
      nodata: false,
      interval: {},
      value: 10
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
    created () {
      this.getblogposts();
    },

    methods: {
      getblogposts() {
        let config = {
          method : 'get',
          url : `https://kharame-devices.herokuapp.com/getBlogPosts`,
        };
        this.loadingdata=true;
        axios(config)
        .then((response) => {
          this.blogsdata  = response.data.message;
          if (this.blogsdata ) {
              this.loadingdata = false;
              this.nodata = false;
          } else {
              setTimeout(() => { this.loadingdata = false; }, 2000);
              setTimeout(() => { this.nodata = true; }, 2000);
          }
        })
      },
      goto_page(id) {
        window.location.href = 'blog/'+id
      }
    },
  }
</script>
<style scoped>
.header1 {
  margin-top:8%;
  text-align: center;
}
.header2 {
  margin-top:2%;
  text-align: center;
  margin-bottom : 5%;
}
.latestbuilds {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 88%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom :2%;
}
.latestbuild {
  margin : 2%;
}
.build {
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6) !important;
}
.v-timeline-item__body a {
  color:whitesmoke;
  text-decoration : none;
}
.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
.foota:hover {
  text-decoration: none;
}
@media (max-width: 1000px) {
  .header1 {
    margin-top: 10%;
  }
}
@media (max-width: 550px) {
  .header1 {
    margin-top: 18%;
  }
  .latestbuilds {
    margin-bottom : 12%;
  }
}

</style>